import type { Lang } from '../i18n/messages';

export interface SocialLink {
  platform: 'facebook' | 'tiktok' | 'youtube';
  href: string;
  label: string;
  glyph: string;
}

const FACEBOOK_URLS: Record<Lang, string> = {
  th: 'https://www.facebook.com/ilovecookingth',
  en: 'https://www.facebook.com/ilovecookingsea/',
};

export function socialLinks(lang: Lang): SocialLink[] {
  return [
    {
      platform: 'facebook',
      href: FACEBOOK_URLS[lang],
      label: 'Facebook',
      glyph: '/images/social-fb.png',
    },
    {
      platform: 'tiktok',
      href: 'https://www.tiktok.com/@ilovecookingth',
      label: 'TikTok',
      glyph: '/images/social-tt.png',
    },
    {
      platform: 'youtube',
      href: 'https://www.youtube.com/@gmillionofficial',
      label: 'YouTube',
      glyph: '/images/social-yt.png',
    },
  ];
}
